var styleDataHash = "20b6ba25";
const injectCss = () => {
  var css = `.LnF8W{height:18px;position:relative;width:18px}.ABRZL,.CIPs3{height:100%;position:absolute;top:0;width:100%;fill:none;stroke-linecap:round}[dir=ltr] .ABRZL,[dir=ltr] .CIPs3{left:0}[dir=rtl] .ABRZL,[dir=rtl] .CIPs3{right:0}.ABRZL{stroke:currentColor;opacity:.3}[dir=ltr] .ABRZL{animation:D96PY 666ms linear infinite}[dir=rtl] .ABRZL{animation:V5rU4 666ms linear infinite}.CIPs3{stroke:currentColor}[dir=ltr] .CIPs3{animation:D96PY 2s linear infinite}[dir=rtl] .CIPs3{animation:V5rU4 2s linear infinite}@keyframes D96PY{to{transform:rotate(1turn)}}@keyframes V5rU4{to{transform:rotate(-1turn)}}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var double_loader_default = {
  "wrapper": "LnF8W",
  "top": "ABRZL",
  "bottom": "CIPs3",
  "rotation-ltr": "D96PY",
  "rotation-rtl": "V5rU4"
};
export {
  double_loader_default as default,
  injectCss
};
//# sourceMappingURL=double-loader-scss.js.map
